import { AttendanceLessonNotStartedDataForm } from './componenets/attendance-lesson-not-started-data-form';
import React from 'react';
import { AttendanceLessonStartedDataForm } from './attendance-lesson-started-data-form';
import { LectureDetails } from '../../../../../../api/types/lecturers/details/lecture-details';

interface LecturePageAttendanceDatamodel {
  lectureDetails?: LectureDetails;
}
export const LecturePageAttendance: React.FC<
  LecturePageAttendanceDatamodel
> = ({ lectureDetails }) => {
  const isLectureStarted =
    Array.isArray(lectureDetails?.lectureInformation.lecturers) &&
    lectureDetails!.lectureInformation.lecturers.some(
      (item) => item.sessions && item.sessions.length > 0,
    );

  return isLectureStarted ? (
    <AttendanceLessonStartedDataForm lectureDetails={lectureDetails!} />
  ) : (
    <AttendanceLessonNotStartedDataForm
      attendanceSessions={lectureDetails?.attendanceSessions}
    />
  );
};
